<template>
  <section :class="{ 'full-section' : !isInHero}">

    <h2 v-if="!isInHero">{{ $t("startForm.title") }}</h2>
    <p v-if="!isInHero">{{ $t("startForm.text") }}</p>

   <form
    @keydown="preventFormSubmit">
    <RyomaInput
      type="text"
      look="default"
      suggestions="services"
      placeholder="Choose your service"
      @serviceSelected="serviceSelected" />
      
    <Cta 
      type="default"
      :text="$t('startForm.cta')"
      :service="selectedService"/>
  </form>

  </section>
</template>

<script>
import RyomaInput from '@/components/form/fields/RyomaInput.vue'
import Cta from '@/components/elements/Cta.vue'

export default {
  name: 'start-form',
  props: ['container'],
  components: {
    RyomaInput,
    Cta
  },
  data () {
    return {
      selectedService: ''
    }
  },
  computed: {
    isInHero: function() {
      return this.container === 'hero';
    }
  },
  methods: {
    serviceSelected: function(service) {
      this.selectedService = service
    },
    preventFormSubmit (e) {
      if(e.keyCode === 13) {
        // !this.selectedService && e.preventDefault()
        e.preventDefault()
      }
		}
  }
}
</script>

<style lang="scss" scoped>
  @import '../../styles/_mixins.scss';

  section {
    &.full-section {
      min-height: 60vh; 
      text-align: center;
      background: map-get($colors--grays, "7");
      color: $gray_light_1;
      @include center-content(column);
    }

    &:not(.full-section) {
      grid-column: 2/ span 10;
    }

    h2 {
      font-weight: 700;
      margin-top: 10vmin;
      color: white;
      line-height: 1.2;
      font-size: 2.25rem;

      @include respond-to(desktop) {
        font-size: 3.25rem;
      }
    }

    p {
      font-size: 1.125rem;
      color: white;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
  }

  form {

  @include respond-to(tablet) {
    max-width: 65vw;
    @include center-content(row);
    margin: 0 auto;
    flex-direction: row;

    fieldset {
      flex: 3;
      margin-bottom: 0;
    }
  }

  @include respond-to(desktop) {
    width: 100%;
    max-width: 50vw;

    fieldset {
      flex: 4;
    }
  }

  @include respond-to(tv) {
    max-width: 40vw;

    fieldset {
      flex: 3;
    }
  }

  button {
    flex: 1;

    @include respond-to(tablet) {
      flex: 2;
      margin-left: 1rem;
    }
  }
}
</style>

